var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuetify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 384,
    viewBox: "0 0 432 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.897 103.248L146.523 230.363L216 350.772L308.021 191.386L400 32H261.005L219.897 103.248Z",
    fill: "#1697F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.021 191.386L128.84 199.768L197.478 80.8258L225.68 32H216H32L124.021 191.386Z",
    fill: "#AEDDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.005 32C295.785 146.458 216 350.772 216 350.772L146.523 230.363L261.005 32Z",
    fill: "#1867C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.68 32C79.1426 32 128.84 199.768 128.84 199.768L225.68 32Z",
    fill: "#7BC6FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuetify);
export default __webpack_public_path__ + "static/media/vuetify.bbf7cb41c1a373da720a5da344781803.svg";
export { ForwardRef as ReactComponent };